
import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

function Protectroute({ children }) {
    const location = useLocation();
    const token = localStorage.getItem('token');
    if (!token) {
        return <Navigate to='/login' replace state={{ from: location.pathname }} />
    }
    return children ?? <Outlet />

}

export default Protectroute
